import { Color } from '../Color';
import { Shadow } from '../Shadow';

export const getPrimaryBtnStatesStyles = () => ({
	hover: {
		background: Color.Tertiary1Light,
		boxShadow: Shadow.ExtraSmall,
		font: {
			color: Color.PrimaryBlue,
		},
	},
	focus: {
		background: Color.Tertiary2Light,
		boxShadow: Shadow.ExtraSmall,
		outline: `1px solid ${Color.PrimaryBlue}`,
		font: {
			color: Color.PrimaryBlue,
		},
	},
	active: {
		background: Color.Tertiary2Light,
		boxShadow: 'none',
		border: 'none',
	},
	disabled: {
		background: Color.Neutral10,
		opacity: '1',
		font: {
			color: Color.PrimaryBlue,
		},
	},
});
